import './ChangePassword.scss';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import UserService from '../../../Services/UserService';
import {
  XpektorForm,
  FormInput,
  FormButton,
} from '../../../Components/XpektorForms/XpektorForms';

const gT = (t, key) => t(`page-change-password${key}`);

/* eslint-disable no-alert */
export default function ChangePassword() {
  const { t } = useTranslation('app');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatNewPassword, setRepeatNewPassword] = useState('');

  const [newPwValid, setNewPwValid] = useState(false);

  const [oldPwErrorText, setOldPwErrorText] = useState('');
  const [newPwErrorText, setNewPwErrorText] = useState('');
  const [repeatNewPwErrorText, setRepeatNewPwErrorText] = useState('');

  useEffect(() => {
    document.title = gT(t, '.document-title');
  }, [t]);

  function validateForm() {
    return (
      oldPassword.length > 0 &&
      newPassword.length > 0 &&
      repeatNewPassword.length > 0 &&
      newPwValid
    );
  }

  function clearErrors() {
    setOldPwErrorText('');
    setNewPwErrorText('');
    setRepeatNewPwErrorText('');
  }

  function validateNewPassword(newPw) {
    if (newPw.length < 8) {
      setNewPwErrorText(gT(t, '.error.new-pw-length-short'));
      setNewPwValid(false);
      return;
    }
    if (newPw.length > 250) {
      setNewPwErrorText(gT(t, '.error.new-pw-length-long'));
      setNewPwValid(false);
      return;
    }

    setNewPwValid(true);
    setNewPwErrorText('');
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const oldPwCorrect = await UserService.validatePw(oldPassword);
    if (!oldPwCorrect) {
      setOldPassword('');
      clearErrors();
      setOldPwErrorText(gT(t, '.error.old-pw-incorrect'));
      return;
    }

    if (newPassword === oldPassword) {
      setNewPassword('');
      setRepeatNewPassword('');
      clearErrors();
      setNewPwValid(false);
      setNewPwErrorText(gT(t, '.error.new-pw-eq-old-pw'));
      return;
    }

    if (newPassword !== repeatNewPassword) {
      setNewPassword('');
      setRepeatNewPassword('');
      clearErrors();
      setNewPwValid(false);
      setRepeatNewPwErrorText(gT(t, '.error.new-pw-not-eq-repeat-pw'));
      return;
    }

    UserService.changePw(oldPassword, newPassword)
      .then((response) => {
        if (response) {
          alert(gT(t, '.pw-changed'));
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          alert(gT(t, '.error.unable'));
        }
        if (error.response.status === 500) {
          alert(gT(t, '.error.general'));
        }
      });
  };

  return (
    <div className="change-password-wrapper">
      <div className="change-password-head">
        <p className="change-password-title">{gT(t, '.title')}</p>
      </div>
      <div className="change-pw-content">
        <div className="change-pw-form-container">
          <XpektorForm onSubmit={handleSubmit}>
            <FormInput
              label={gT(t, '.form-input-label.old-pw')}
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              infoText={oldPwErrorText}
            />
            <FormInput
              label={gT(t, '.form-input-label.new-pw')}
              type="password"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                validateNewPassword(e.target.value);
              }}
              infoText={newPwErrorText}
            />
            <FormInput
              label={gT(t, '.form-input-label.repeat-pw')}
              type="password"
              value={repeatNewPassword}
              onChange={(e) => setRepeatNewPassword(e.target.value)}
              infoText={repeatNewPwErrorText}
            />
            <FormButton
              text={gT(t, '.form-btn.text')}
              disabled={!validateForm()}
            />
          </XpektorForm>
        </div>
      </div>
    </div>
  );
}
